import { memo, useCallback, useMemo } from "react";

import { useProduct } from "@shopify/hydrogen-react";

import { useSectionSettings } from "@react/sections/Root/SectionSettingsContext";
import { type ProductHeroSettings } from "@root/tablescape/state";
import { formatProductVariant } from "@root/tablescape/utilities";

import { ProductGalleryGridView } from "./ProductGalleryGrid.view";

type Props = {
  videoLabel: string;
};
const ProductGalleryGridBase = ({ videoLabel }: Props) => {
  const { selectedVariant } = useProduct();
  const {
    productGalleryGrid: { lcpMedia },
    settings: { lazyLoadImages },
  } = useSectionSettings<ProductHeroSettings>();

  const medias = useMemo(
    () => formatProductVariant(selectedVariant).media,
    [selectedVariant]
  );

  const showProductValueProps = useCallback(
    (index: number) =>
      (medias.length < 4 && index === 0) || (medias.length > 3 && index === 2),
    [medias]
  );

  return (
    <ProductGalleryGridView
      lazyLoadImages={lazyLoadImages}
      lcpMedia={lcpMedia}
      medias={medias}
      showProductValueProps={showProductValueProps}
      videoLabel={videoLabel}
    />
  );
};

export const ProductGalleryGrid = memo(ProductGalleryGridBase);
